import { press } from "../../utils/content";

export default function Press() {
  let videoContent = press.filter((x) => x.type === "video");
  videoContent.sort((a, b) => b.datetime - a.datetime);
  let articleContent = press.filter((x) => x.type === "article");
  articleContent.sort((a, b) => b.datetime - a.datetime);

  return (
    <section
      id="press"
      aria-label="Press converage for audico Health"
      className="relative py-32 sm:pb-48"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl md:text-center">
          <h2 className="font-display tracking-tight text-white text-3xl sm:text-4xl md:text-5xl gotham-bold">
            In the news
          </h2>
          <p className="mt-4 text-lg tracking-tight text-light">
            Here's some of the coverage that we've received from around the
            world within the Hospitality industry.
          </p>
        </div>

        {/* Articles */}
        <h2
          className="text-3xl font-bold leading-7 text-info mt-24 sm:mt-36 text-center"
          id="articles"
        >
          Articles
        </h2>
        <div className="mx-auto mt-10 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-12 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {articleContent.map((post) => (
            <article
              key={post.id}
              className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-transparent px-8 pb-8 pt-32 sm:pt-36 lg:pt-40 hover:ring-2 hover:ring-offset-4 hover:ring-info outline outline-secondary"
            >
              <img
                src={post.bgImage}
                alt=""
                className="absolute inset-0 -z-10 h-full w-full object-cover"
              />
              <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />
              <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />

              <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm leading-6 text-gray-300">
                <time className="mr-8">{post.date}</time>
              </div>
              <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                <a target="_blank" href={post.href} rel="noreferrer">
                  <span className="absolute inset-0" />
                  {post.title}
                </a>
              </h3>
            </article>
          ))}
        </div>

        {/* Videos */}
        <h2
          className="text-3xl font-bold leading-7 text-info mt-24 sm:mt-36 text-center"
          id="videos"
        >
          Videos
        </h2>
        <div className="mx-auto mt-10 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-12 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {videoContent.map((video) => (
            <iframe
              key={video.id}
              title={video.title}
              src={video.href}
              className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-transparent hover:ring-2 hover:ring-offset-4 hover:ring-info outline outline-secondary w-full h-64"
            />
          ))}
        </div>
      </div>

      {/* <div className="mt-16 flex justify-center">
        <a href="#!" className="bg-info px-8 py-3 leading-6 text-white drop-shadow rounded-full text-xl font-bold hover:bg-fuchsia-800">
          Read our customer success stories here →
        </a>
      </div> */}
    </section>
  );
}
